import { Store } from '@webtides/element-js';

export default class SocialMediaWallStore extends Store {
    #BASE_API_URL = 'https://api.flockler.app/v2/';
    append = true;

    properties() {
        return {
            channel: 'all',
            channels: [],
            isLoading: false,
            posts: [],
            apiKey: '',
            siteUuid: '',
        };
    }

    watch() {
        return {
            channel: async () => {
                this.append = false;
                await this.updatePosts();
                this.append = true;
            },
        };
    }

    getPosts() {
        return this.posts;
    }

    extractActiveChannelValues() {
        return this.channels.filter(channel => channel.value !== 'all').map(channel => channel.value);
    }

    async updatePosts() {
        let { posts, pagination, meta } = await this.fetchPosts();
        this.posts = this.append ? [...this.posts, ...posts] : posts;
    }

    get queryParameters() {
        const parameters = {
            ...{ count: 7 },
            ...(this.posts.length > 0 &&
                this.append && { olderThanCursor: this.posts[this.posts.length - 1].flocklerId }),
        };
        const searchParams = new URLSearchParams(parameters);
        this.channel !== 'all'
            ? searchParams.append('filterByChannels[]', this.channel)
            : this.extractActiveChannelValues().forEach(channel => searchParams.append('filterByChannels[]', channel));
        return searchParams.toString();
    }

    async fetchPosts() {
        let response = await fetch(`${this.#BASE_API_URL}${this.siteUuid}/posts?${this.queryParameters}`, {
            method: 'GET',
            headers: {
                'X-FL-API-KEY': this.apiKey,
            },
        });
        return response.json();
    }
}
